/**
 * Created by lihanying on 2017/6/29.
 */
import { GETADVERTLIST, GETADVERTSETTING } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETADVERTLIST:
      return Object.assign({}, state, { advertList: action.payload })
    case GETADVERTSETTING:
      return Object.assign({}, state, { advertSetting: action.payload })
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/AdvertManage/reduce.js